import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import InputBox from "../../../FormElement/InputBox";
import { FacilityReportsSearchParams } from "../hooks";

import "./styles.scss";

interface IFacilityReportsListControlsProps {
  searchParams: FacilityReportsSearchParams;
  setSearchParams: React.Dispatch<
    React.SetStateAction<FacilityReportsSearchParams>
  >;
}

export const FacilityReportsListControls: React.FunctionComponent<
  IFacilityReportsListControlsProps
> = (props) => {
  const { searchParams, setSearchParams } = props;
  const { t } = useTranslation();
  const tFilter = (key: string) =>
    t(`facilityReportsPage.facilityReportsList.controls.${key}`);

  const [inputValue, setInputValue] = useState(
    searchParams.location_name ?? ""
  );

  useEffect(() => {
    setInputValue(searchParams.location_name ?? "");
  }, [searchParams.location_name]);

  const hasActiveFilter = (searchParams.location_name ?? "").trim() !== "";

  const handleApply = () => {
    setSearchParams((sp) => ({
      ...sp,
      location_name: inputValue.trim() || undefined,
      offset: 0,
    }));
  };

  const handleClear = () => {
    setInputValue("");
    setSearchParams((sp) => ({
      ...sp,
      location_name: undefined,
      offset: 0,
    }));
  };

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleApply();
    }
  };

  return (
    <div className="facility-reports-list-controls">
      <InputBox
        type="text"
        isSearch
        placeholder={tFilter("search_placeholder")}
        value={inputValue}
        onChange={(value) => setInputValue(value)}
        onKeyPress={handleKeyPress}
      />
      <button
        type="button"
        className="facility-reports-list-controls-button btn btn-border"
        onClick={handleApply}
      >
        {tFilter("apply")}
      </button>
      {hasActiveFilter && (
        <button
          type="button"
          className="facility-reports-list-controls-button btn btn-border btn-border-red"
          onClick={handleClear}
        >
          {tFilter("clear")}
        </button>
      )}
    </div>
  );
};
